export type Periodicidad = 'T' | 'S' | 'A';
export type TipoRevision = 'trimestral' | 'semestral' | 'anual';
export type TipoRespuesta = 'si_na_no' | 'numero' | 'texto';

export interface ChecklistPregunta {
  id: string;
  texto: string;
  periodicidad: Periodicidad[];
  tipo_respuesta?: TipoRespuesta;
  unidades?: boolean;
  nota?: string;
}

export interface ChecklistCabeceraCampo {
  key: string;
  label: string;
  tipo?: 'text' | 'number' | 'date';
}

export interface ChecklistProtocolo {
  id: string;
  titulo: string;
  cabecera?: ChecklistCabeceraCampo[];
  preguntas: ChecklistPregunta[];
  /** Render especial del bloque en UI y PDF. Si está presente, las preguntas no se muestran. */
  tipo_render?: 'curva_caudal';
  /** Periodicidades en las que el bloque debe mostrarse (si se omite, siempre). */
  periodicidad?: Periodicidad[];
}

export interface ChecklistTemplate {
  tipo_sistema: string;
  titulo: string;
  protocolos: ChecklistProtocolo[];
}

// Filtra preguntas según el tipo de revisión seleccionado.
// Reglas:
//   - trimestral: preguntas que incluyan 'T'.
//   - semestral: preguntas que incluyan 'S' (las S/A entran aquí).
//   - anual: todas las preguntas (T, S y A).
export const filtrarPorTipoRevision = (
  preguntas: ChecklistPregunta[],
  tipo: TipoRevision
): ChecklistPregunta[] => {
  if (tipo === 'anual') return preguntas;
  if (tipo === 'trimestral') return preguntas.filter(p => p.periodicidad.includes('T'));
  return preguntas.filter(p => p.periodicidad.includes('S'));
};

export const TIPO_REVISION_LABEL: Record<TipoRevision, string> = {
  trimestral: 'Trimestral',
  semestral: 'Semestral',
  anual: 'Anual',
};
